import { render, staticRenderFns } from "./create-container.vue?vue&type=template&id=1ef0650f&"
import script from "./create-container.vue?vue&type=script&lang=js&"
export * from "./create-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports